export const solicitudEstados = {
  Nueva: 0,
  Aprobada: 1,
  Cancelada: 2,
  Rechazada: 3,
  Confirmada: 4,
  Ejecución: 5,
  Finalizada: 6,
};
